import { useTranslate } from '@tolgee/react';
import { useState } from 'react';
import { Button } from '~/components/ui/Button';
import { WrapperWidget } from '@agentselly/ui';
import { useAppParams } from '~/helper/useAppParams';

interface Props {
  readonly params?: {
    readonly lang: string;
    readonly companyId: string;
    readonly contactId: string;
    readonly propertyId: string;
  };
}

export function ExposeViewWidget(props: Props) {
  const { t } = useTranslate();
  const [
    isLoading,
    setIsLoading,
  ] = useState(true);

  // Use useAppParams to extract params from current URL
  const routeParams = useAppParams();

  // Use props.params first (from backend), fallback to useAppParams (from URL)
  const params = props.params || routeParams;

  function getUrl(action: 'view' | 'download') {
    const safeParams = params || {
      lang: 'de',
      companyId: '',
      contactId: '',
      propertyId: '',
    };
    return `/${safeParams.lang}/${safeParams.companyId}/public/expose/${safeParams.contactId}/${safeParams.propertyId}/file/${action}`;
  }

  return (
    <WrapperWidget>
      <div className="flex flex-col gap-4">
        <p>{t('expose_view_description')}</p>
        <div className="relative w-full min-h-[65vh]">
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-50 dark:bg-gray-800 dark:bg-gray-900 rounded-md border">
              <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-300 dark:border-gray-600 border-t-primary-400"></div>
            </div>
          )}
          <iframe
            className="border rounded-md w-full min-h-[65vh] h-full"
            src={getUrl('view')}
            title={t('expose_view_iframe_title')}
            style={{
              display: 'block',
              overflow: 'hidden',
            }}
            frameBorder="0"
            onLoad={() => setIsLoading(false)}
          />
        </div>
        <div className="flex flex-row gap-4 w-full">
          <a
            href={getUrl('view')}
            target="_blank"
            rel="noreferrer"
          >
            <Button
              primary
              showArrow
            >
              {t('expose_view_external_view_button')}
            </Button>
          </a>
          <a
            href={getUrl('download')}
            target="_blank"
            rel="noreferrer"
          >
            <Button
              primary
              showArrow
            >
              {t('expose_view_external_download_button')}
            </Button>
          </a>
        </div>
      </div>
    </WrapperWidget>
  );
}
